import { render } from "./index.vue?vue&type=template&id=8b741124&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8b741124&lang=scss"
import "./index.vue?vue&type=style&index=1&id=8b741124&scoped=true&lang=scss"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b741124"]])

export default __exports__